import type { ErrorMessage } from '@repo/types/messages/error';
import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorMessageHandler } from '@repo/lib/errorMessageHandler';
import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useMemo } from 'react';

export function useErrorMessage(error: unknown, messages: ErrorMessages = baseErrorMessages, defaultError?: ErrorMessage): ErrorMessage {
  const handler = useMemo<ErrorMessageHandler>((): ErrorMessageHandler => new ErrorMessageHandler(messages, defaultError), [messages, defaultError]);

  return useMemo<ErrorMessage>(() => {
    return handler.processError(error);
  }, [handler, error]);
}
